import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, ConnectableObservable, interval, ObjectUnsubscribedError, Observable, Subject } from "rxjs";
import { concatMap, finalize, multicast, shareReplay } from "rxjs/operators";
import { Notification, NotificationType } from "../shared/models/Notification";
import { SessionUser } from "../shared/models/sessionUser";
import { TokenStorageService } from "./token-storage.service";
import * as signalR from "@microsoft/signalr";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { RegistroAlerta } from "../models/Alertas/RegistroAlerta";
import { Response } from "../shared/models/Response";
import { LocalStorageService } from "./local-storage.service";
import Swal from "sweetalert2";

const mockNotifications = [
	new Notification(NotificationType.Peligro, "Error de Emisión", "Factura de cliente Entel no fue emitida", "/documentos-emitidos"),
	new Notification(NotificationType.Advertencia, "XML no enviados", "Quedaron 5 DTE pendientes de envío al SII", "/documentos-emitidos"),
	new Notification(NotificationType.Informacion, "Documentos emitidos", "Se enviaron 22 DTE emitidos al SII", "/documentos-emitidos"),
	new Notification(NotificationType.Advertencia, "Folios por vencer", "Quedan 5  folios para emitir facturas electronicas", "/folios"),
	new Notification(NotificationType.Peligro, "Certificado vencido", "El certificado para la emisión de dte se ha vencido", "/certificados"),
];

const maintainerRoutes = new Map([
	["folio", "/folios"],
	["timbraje", "/folios"],
	["certificado", "/certificados"],
	["facturación", "/facturacion-masiva"],
	["documentos", "ventas/documentos-emitidos"],
]);
@Injectable({
	providedIn: "root",
})
export class NotificationService implements OnInit {
	private REST_API_SERVER = environment.backend_server + "/Alerta";
	sessionNotifications: Notification[] = [];
	sessionAlerts: RegistroAlerta[] = [];
	currentUser: SessionUser;
	currentEmisorId: string;
	newNotification$: Observable<boolean>;
	newNotificationSubject: BehaviorSubject<boolean>;
	hubConnections: signalR.HubConnection[] = [];
	_notificationsSubject: Subject<Notification> = new BehaviorSubject<Notification>(mockNotifications[0]);
	readonly notifications = this._notificationsSubject.asObservable().pipe(shareReplay());
	readonly notificationsInterval;
	//Mock  notifications service
	multiNotifications = this.notifications.pipe(multicast(() => new Subject<Notification>())) as ConnectableObservable<Notification>;
	private loadingAlertsSubject: BehaviorSubject<boolean>;
	public isLoadingAlerts: Observable<boolean>; // show if alert list request is done
	private alertListSubject: BehaviorSubject<RegistroAlerta[]>;
	public alertListObservable: Observable<RegistroAlerta[]>;
	private loadindReadRequestSubject: BehaviorSubject<boolean>;
	public isloadingReadAlertRequest: Observable<boolean>; // show if read alert request is done

	constructor(private tokenService: TokenStorageService, private http: HttpClient, private localStorage: LocalStorageService) {
		this.newNotificationSubject = new BehaviorSubject<boolean>(false);
		this.newNotification$ = this.newNotificationSubject.asObservable();
		this.currentUser = this.tokenService.getUser() as SessionUser;
		this.currentEmisorId = this.tokenService.getCompany();
		this.loadingAlertsSubject = new BehaviorSubject<boolean>(true);
		this.isLoadingAlerts = this.loadingAlertsSubject.asObservable();
		this.alertListSubject = new BehaviorSubject<RegistroAlerta[]>([]);
		this.alertListObservable = this.alertListSubject.asObservable();
		this.loadindReadRequestSubject = new BehaviorSubject<boolean>(false);
		this.isloadingReadAlertRequest = this.loadindReadRequestSubject.asObservable();
		// if (this.currentUser && this.currentEmisorId) {
		//   this.multiNotifications.connect();
		//   this.tokenService.userIsLogged.subscribe((value) => {
		//     if (value) {
		//       this.signalAlertConnection(this.currentEmisorId);
		//     }
		//   });
		// }
		this.checkNotifications();
		this.multiNotifications.connect();

		this.tokenService.currentEmisorIdEmitter.subscribe((emisorId: string) => {
			if (emisorId != this.currentEmisorId) {
				this.hubConnections.forEach((connection) => {
					connection.stop().then(function () {
					});
				});
				this.currentEmisorId = emisorId;
				this.currentUser = this.tokenService.getUser() as SessionUser;
				this.signalAlertConnection(emisorId, this.currentUser.id);
			}
		});
		if (this.currentEmisorId) {
			this.tryReconnect(this.currentEmisorId, this.currentUser.id);
		}
	}

	ngOnInit() {}
	tryReconnect(emisorID: string, usuarioId: string) {
		this.signalAlertConnection(emisorID, usuarioId);
	}
	signalAlertConnection(emisorDelGrupo, usuarioId) {
		if (usuarioId != undefined && usuarioId != null && usuarioId != "") {
			let connection = new signalR.HubConnectionBuilder().configureLogging(signalR.LogLevel.Information).withUrl(environment.signalR_server).build();

			connection
				.start()
				.then(() => {
					connection.invoke("JoinGroup", [usuarioId]).catch((err) => {
					});
					this.hubConnections.push(connection);
					this.hubConnections = [...this.hubConnections];
				})
				.catch(function (err) {
					return console.error(err.toString());
				});

			connection.on("JoinGroupName", (nombresGrupos) => {
			});

			connection.on("globalAlerts", (alertType: number, alertTitle, message, groupNames) => {
				// let notifToPush = new Notification(
				//   (<any>NotificationType)[NotificationType[alertType]],
				//   alertTitle,
				//   message
				// );
				// this.getLinkFromTitle(notifToPush);
				// this.pushNotificationToSubject(notifToPush);

				var exist = false;
				this.directAlertRefresh();
				groupNames.forEach((element) => {
					if (element == this.currentUser.id) exist = true;
				});
				if (exist) this.hubAlertsToFrontNotifications(alertType, alertTitle, message);
			});

			connection.on("groupAlerts", (alertType, alertTitle, message, groupNames) => {
				this.hubAlertsToFrontNotifications(alertType, alertTitle, message);
				setTimeout(() => {
					this.directAlertRefresh();
				}, 4000);
			});
			connection.onclose(async () => {
			});
		}
	}

	pushNotificationToSubject(notif: Notification) {
		this._notificationsSubject.next(notif);
		this.newNotificationSubject.next(true);
	}

	getLinkFromTitle(notification: Notification) {
		for (let key of maintainerRoutes.keys()) {
			if (notification.title.toLowerCase().includes(key)) {
				notification.link = maintainerRoutes.get(key);
				break;
			} else {
				notification.link = "/";
			}
		}
	}

	hubAlertsToFrontNotifications(alertType, alertTitle, message) {
		let newNotif = new Notification((<any>NotificationType)[NotificationType[alertType]], alertTitle, message);
		this.getLinkFromTitle(newNotif);
		this.pushNotificationToSubject(newNotif);
	}

	hubStopConnections() {
		this.hubConnections.forEach((connection) => {
			connection.stop().then(() => {});
		});
	}

	searchForNotifications() {
		this.loadingAlertsSubject.next(true);
		const currentUser = this.tokenService.getUser() as SessionUser;
		return this.http.get<Response<RegistroAlerta[]>>( `${this.REST_API_SERVER}/getAllRecords/${currentUser.id}`).pipe(finalize(() => this.loadingAlertsSubject.next(false)));
	}

	checkNotifications() {
		//check if notifications are currently loaded, load from localhost or request all of them
		this.tokenService.getUser() as SessionUser;
		this.loadingAlertsSubject.next(false);
		this.loadAlertNotification();
	}

	loadAlertNotification() {
		this.sessionAlerts = this.localStorage.getAlertas();
		if (this.currentUser.id) {
			this.sessionAlerts = [];
			this.directAlertRefresh();
		} else {
			this.alertListSubject.next(this.sessionAlerts);
		}
	}

	directAlertRefresh() {
		this.searchForNotifications().subscribe(
			(result) => {
				this.sessionAlerts = result.data;
				this.localStorage.saveAlertas(this.sessionAlerts);
				this.alertListSubject.next(this.sessionAlerts);
				//this.checkForEnvironmentChangeAlert(this.sessionAlerts);
			},
			(error) => {
			}
		);
	}
	agruparPorParam(arr, func) {
		return arr.reduce((r, v, i, a, k = func(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
	}

	obtenerUltimaAlertadeAmbiente(arrayGroupedAlerts: any[]): RegistroAlerta[] {
		let emisorIds = Object.keys(arrayGroupedAlerts);
		let lastAlertsForEmisores = [];
		emisorIds.forEach((id) => {
			let alertsOfEmisor = arrayGroupedAlerts[id] as RegistroAlerta[];
			let lastAlert = alertsOfEmisor.reduce((a, b) => (a.fechaCreacion > b.fechaCreacion ? a : b));
			lastAlertsForEmisores.push(lastAlert);
		});
		return lastAlertsForEmisores;
	}
	checkForEnvironmentChangeAlert(alerts: RegistroAlerta[]) {
		if (alerts.some((alert) => alert.alertaId == "14")) {
			let alertsEnvironmentChanged = alerts.filter((alert) => alert.alertaId == "14");
			let environmentAlertsByEmisor = this.agruparPorParam(alertsEnvironmentChanged, (a) => a.emisorId);

			if (alertsEnvironmentChanged && alertsEnvironmentChanged.length > 0 && environmentAlertsByEmisor && Object.keys(environmentAlertsByEmisor).length > 0) {
				let enviroAlerts = this.obtenerUltimaAlertadeAmbiente(environmentAlertsByEmisor);
				enviroAlerts.forEach((alert) => {
					let ambiente = alert.mensaje.includes("Certificación") ? 0 : alert.mensaje.includes("Producción") ? 1 : undefined;
					if (ambiente == undefined) {
						Swal.fire({
							icon: "error",
							title: "Cambio de Ambiente",
							text: "Se ha detectado un cambio de ambiente para un emisor asociado pero no ha sido posible sincronizar el nuevo ambiente. Cierre su sesión y vuelva a ingresar al sistema.",
						});
						return;
					}
					this.tokenService.updateAmbientOfCompany(alert.emisorId, ambiente);
				});
			}
		}
	}
	readAlertRequest(alerta: RegistroAlerta) {
		this.loadindReadRequestSubject.next(true);
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/readAlert/" + alerta.registroAlertaId, null).pipe(finalize(() => this.loadindReadRequestSubject.next(false)));
	}
	markAllAlertsAsRead(usuarioId: string): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(`${this.REST_API_SERVER}/readAllAlerts`,  { usuarioId: usuarioId } ).pipe(finalize(() => this.loadindReadRequestSubject.next(false)));
	  }

	clearAlerts(): void {
		this.sessionAlerts = [];
		this.alertListSubject.next([]);
		this.localStorage.saveAlertas([]);
	}

}
